/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $MatchMini = {
    properties: {
        id: {
            type: 'number',
            isRequired: true,
        },
        team1Id: {
            type: 'number',
            isRequired: true,
        },
        team2Id: {
            type: 'number',
            isRequired: true,
        },
        goal1: {
            type: 'number',
            isRequired: true,
        },
        goal2: {
            type: 'number',
            isRequired: true,
        },
    },
} as const;
